export default __webpack_public_path__ + "static/media/bannerBr.5e8e7246.png";